<template>
<div>
  <H1 :className="textStyle" :text="copy"></H1>
  <ol class="c-list-order mt30">
    <ListItem
      v-for="(disc, index) in introDisc"
      :key="disc.key"
      :className="'c-list-order__text--'+ index"
      :text="disc.msg">
    </ListItem>
  </ol>
  <Text className="c-text-ss" text="※このプレビューはイメージです"></Text>
  <Text className="c-text-ss" text="※スマホでも画像を作れますが保存はできません"></Text>
  <Text className="c-text-ss" text="※Google Chrome / Firefoxをご利用ください（Safari非対応です）"></Text>
</div>
</template>

<script>
import H1 from '@/components/atoms/H1.vue'
import ListItem from '@/components/atoms/ListItem.vue'
import Text from '@/components/atoms/Text.vue'

export default {
  name: 'CopyAndList',
  props: {
    copy: String,
    introDisc: Array,
    textStyle: String
  },
  components: {
    H1,
    ListItem,
    Text
  }
}

</script>

<style lang="scss" scoped>
.c-list-order {
  padding-left: 30/1280*100vw;
  box-sizing: border-box;
  font-size: 24/1280*100vw;
  font-weight: 700;
  line-height: 18/1280*100;
  @include media-queries-sp {
    font-size: 15/375*100vw;
  }

  &__text {
    margin-bottom: 16/1280*100vw;
    position: relative;
    @include media-queries-sp {
      margin-bottom: 16/375*100vw;
    }
    &::before {
      width: 24/1280*100vw;
      height: 24/1280*100vw;
      color: #fff;
      font-size: 15/1280*100vw;
      line-height: 21/1280*100;
      text-align: center;
      border-radius: 16/1280*100vw;
      background: $color_blue_light;
      position: absolute;
      top: 6/1280*100vw;
      left: -30/1280*100vw;
      @include media-queries-sp {
        width: 24/375*100vw;
        height: 24/375*100vw;
        font-size: 14/375*100vw;
        line-height: 1.6;
        border-radius: 16/375*100vw;
        top: 0;
        left: -30/375*100vw;
      }
    }
    &--0{
      @extend .c-list-order__text;
      &::before {
        content: '1';
      }
    }
    &--1{
      @extend .c-list-order__text;
      &::before {
        content: '2';
      }
    }
    &--2{
      @extend .c-list-order__text;
      &::before {
        content: '3';
      }
    }
    &--3{
      @extend .c-list-order__text;
      &::before {
        content: '4';
      }
    }
  }
}
</style>
